import { Component, ElementRef, ViewContainerRef, ValueProvider, Renderer2, Injector, ChangeDetectionStrategy, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ComponentBase, IComponentBase, applyMixins, ComponentMixins, PropertyCollectionInfo, FormBase, setValue } from '@syncfusion/ej2-angular-base';
import { DateTimePicker } from '@syncfusion/ej2-calendars';



export const /** @type {?} */ inputs: string[] = ['allowEdit','calendarMode','cssClass','depth','enablePersistence','enableRtl','enabled','firstDayOfWeek','floatLabelType','format','isMultiSelection','locale','max','min','placeholder','readonly','scrollTo','showClearButton','showTodayButton','start','step','strictMode','timeFormat','value','values','weekNumber','width','zIndex'];
export const /** @type {?} */ outputs: string[] = ['blur','change','close','created','destroyed','focus','navigated','open','renderDayCell','valueChange'];
export const /** @type {?} */ twoWays: string[] = ['value'];
/**
 * Represents the Essential JS 2 Angular DateTimePicker Component.
 * ```html
 * <ejs-datetimepicker [value]='dateTime'></ejs-datetimepicker>
 * ```
 */
@ComponentMixins([ComponentBase, FormBase])
export class DateTimePickerComponent extends DateTimePicker implements IComponentBase {
public valueChange: any;
private skipFromEvent:boolean = true;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];
        try {
                let mod = this.injector.get('CalendarsIslamic');
                if(this.injectedModules.indexOf(mod) === -1) {
                    this.injectedModules.push(mod)
                }
            } catch { }

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnChange(registerFunction: (_: any) => void): void {
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnTouched(registerFunction: () => void): void {
    }
/**
 * @param {?} value
 * @return {?}
 */
public writeValue(value: any): void {
    }
/**
 * @param {?} disabled
 * @return {?}
 */
public setDisabledState(disabled: boolean): void {
    }
/**
 * @return {?}
 */
public ngOnInit() {
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ejs-datetimepicker',
    inputs: inputs,
    outputs: outputs,
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DateTimePickerComponent),
            multi: true
        }
    ],
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
}

function DateTimePickerComponent_tsickle_Closure_declarations() {
/** @type {?} */
DateTimePickerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DateTimePickerComponent.ctorParameters;
/** @type {?} */
DateTimePickerComponent.prototype.valueChange;
/** @type {?} */
DateTimePickerComponent.prototype.skipFromEvent;
/** @type {?} */
DateTimePickerComponent.prototype.registerEvents;
/** @type {?} */
DateTimePickerComponent.prototype.addTwoWay;
/** @type {?} */
DateTimePickerComponent.prototype.ngEle;
/** @type {?} */
DateTimePickerComponent.prototype.srenderer;
/** @type {?} */
DateTimePickerComponent.prototype.viewContainerRef;
/** @type {?} */
DateTimePickerComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
